import {combineReducers} from 'redux'
import {FetchedAccounts} from "./FetchedAccounts"
import {Patterns}        from "./Patterns"

export const Keywords = combineReducers({
  FetchedAccounts,
  Patterns,
})

